import { useEffect } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { useCurrentPage } from '../../common/hooks/useCurrentPage';
import { biEngagementSlice } from '../../common/reducers/biEngagement';
import { Page } from '../../common/types';
import { widgetSDK } from '../../sdk/widgetSDK';
import { renderModel } from '../../util/renderModel';
import { logWidgetPageEngagement } from '../loggers';

const BI_ENGAGEMENT_INTERVAL = 10 * 1000;

export const useBiEngagement = (): void => {
  const store = useStore();
  const dispatch = useDispatch();
  const currentPage = useCurrentPage();
  const location = useLocation();

  useEffect(() => {
    const intervalId = setInterval(async () => {
      const isWidgetAndCollapsed = renderModel.isWidget() && !(await widgetSDK.isWidgetExpanded());
      const isChatbotPage = currentPage === Page.Chatbot;

      if (document.hidden || isWidgetAndCollapsed || isChatbotPage) {
        return;
      }

      logWidgetPageEngagement(store.getState(), { currentPage });

      dispatch(biEngagementSlice.actions.reset());
    }, BI_ENGAGEMENT_INTERVAL);

    return () => clearInterval(intervalId);
  }, [location]);
};
